import React from "react";
import { Container, Input, AutoComplete } from "./Nav.style";
import PlacesAutocomplete from "react-places-autocomplete";

const Search = (props) => {
  const handleSelect = (value, placeId) => {
    props.setAddress(value);
    const service = new window.google.maps.places.PlacesService(
      document.createElement("div")
    );
    service.getDetails({ placeId, fields: ["geometry"] }, (place, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        props.setLat(place.geometry.location.lat());
        props.setLong(place.geometry.location.lng());
      }
    });
  };

  return (
    <>
      <PlacesAutocomplete
        value={props.address}
        onChange={props.setAddress}
        onSelect={handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <Container>
            <Input
              {...getInputProps({
                placeholder: "Search City",
              })}
            />
            <AutoComplete>
              {loading && <div>Loading...</div>}
              {suggestions.map((suggestion) => {
                return (
                  <div
                    key={suggestion.placeId}
                    {...getSuggestionItemProps(suggestion)}
                  >
                    {suggestion.description}
                  </div>
                );
              })}
            </AutoComplete>
          </Container>
        )}
      </PlacesAutocomplete>
    </>
  );
};

export default Search;
